import apiClient from "./api";
const SINONIMOS_API_BASE_URL = "/sinonimos";
class SinonimosService {
    
async getSinonimosPorEstudio(estudioId) {
    try {
      const response = await apiClient.get(`${SINONIMOS_API_BASE_URL}/estudio/${estudioId}`,);
      return response.data.sinonimos;
    } catch (error) {
      console.error(error);
    }
  }
}
export default new SinonimosService();